import { Injectable } from "@angular/core";
import { Http, Headers, RequestOptions, URLSearchParams } from "@angular/http";
import "rxjs/add/operator/map";
import { Observable } from "rxjs/Observable";
import "rxjs/Rx";
import { UUID } from "angular2-uuid";
import { CryptoUtils } from "../core/encryption/crypto.utils";
import { EncApiList } from "../core/encryption/enc_api_list";

declare var swal: any;
// @Injectable()
export class BaseProvider {
    API_URL = "https://api.wsfx.in/";
    // API_URL = 'https://api.wsfxglobalpay.com/';
    // API_URL = 'https://api2.wsfx.in/';
    // API_URL = 'http://192.168.1.47:5001/';
    // API_URL = "http://localhost:5000/";
    // API_URL = "https://apiqa.wsfx.in/";
    apiKeyTest = "api-od926q416295z936kw76v1g9no952064";

    public headers: Headers;
    public options: RequestOptions;
    public phttp: Http;
    public error: Error;
    public status: number;
    public errorMessage: string;
    public lastapirequest: any;
    public isSessionTimeSec: number = +localStorage.getItem("timeOutInSeconds");
    public encApiList: EncApiList = new EncApiList();
    public cryptoUtils: CryptoUtils = new CryptoUtils();

    constructor(http: any) {
        this.headers = new Headers();
        this.phttp = <Http>http;
        this.addHeader("Content-Type", "application/json");

        this.options = new RequestOptions({ headers: this.headers });
        this.lastapirequest = localStorage.getItem("lastapirequest");
        let timeDiff = Date.now() - this.lastapirequest;
    }

    getHeaders(res) {
        // getting common headers for the REST call
        this.addHeader("Cache-Control", "no-cache");
        this.addHeader("Content-Type", "application/json");
        this.addHeader("clientid", "spicefx");
        // this.addHeader('channel', 'PARTNER_PORTAL');
        this.addHeader("channel", "ADMIN_PORTAL");
        this.addHeader("Cache-Control", "no-cache");
        if (localStorage.getItem("iid")) {
            this.addHeader("iid", localStorage.getItem("iid"));
        } else {
            let uuid = UUID.UUID();
            this.addHeader("iid", uuid);
            localStorage.setItem("iid", uuid);
        }
        if (res == "users/login?scope=full") {
            this.addHeader("X-AUTH-TOKEN", this.apiKeyTest);
        } else if (localStorage.getItem("X-AUTH-TOKEN")) {
            this.addHeader(
                "X-AUTH-TOKEN",
                JSON.parse(localStorage.getItem("X-AUTH-TOKEN")).token,
            );
        } else {
            this.addHeader("X-AUTH-TOKEN", this.apiKeyTest);
        }
        if (localStorage.getItem("X-PORTAL-TOKEN")) {
            this.addHeader("X-PORTAL-TOKEN", localStorage.getItem("X-PORTAL-TOKEN"));
        }
        let clientToken;
        if (localStorage.getItem("Latitude") != null) {
            clientToken =
                localStorage.getItem("IP") +
                "," +
                localStorage.getItem("Latitude") +
                "," +
                localStorage.getItem("Longitude");
            clientToken = btoa(clientToken);
        } else {
            clientToken = localStorage.getItem("IP");
            clientToken = btoa(clientToken);
        }
        this.addHeader("X-CLIENT-TOKEN", clientToken);
        this.options = new RequestOptions({ headers: this.headers });
        // this.setTimerValues();
        return this.options;
    }

    addHeader(key: string, value: string) {
        // Add a particular Header for the REST call
        this.headers.set(key, value);
    }

    getJSONfromModel(model) {
        // Converts an object into into string
        if (model) {
            return JSON.stringify(model);
        }
    }

    checkEndPointMatch(resourceURL) {
        return this.encApiList.encApi.find((apiEndPoint) => {
            if (apiEndPoint == resourceURL) {
                console.log("API end point : ", resourceURL);
                return true;
            }
            return false;
        });
    }

    /*
            Function for POST call
            Parameters:
            resourceURL: The resource on which POST call has to be made.
            requestModel: The Request model to be sent along with the call.
            Return Type: Observable<T>
        */
    makePostCall(resourceURL: string, requestModel: any) {
        console.log("resourceURL_+_+", resourceURL);
        let reqBody = this.getJSONfromModel(requestModel);
        if (this.checkEndPointMatch(resourceURL)) {
            try {
                reqBody = this.cryptoUtils.reqEncrypt(reqBody);
            } catch (err) {
                console.log("Error in encryption!!", err);
            }
        }

        return this.phttp
            .post(this.API_URL + resourceURL, reqBody, this.getHeaders(resourceURL))
            .map((res) => {
                if (this.checkEndPointMatch(resourceURL)) {
                    let resDecpt = this.cryptoUtils.resDecrypt(res["_body"]);
                    res["_body"] = resDecpt;
                }
                return res;
            })
            .catch(this.handleError);
    }

    makePostCallWithoudBody(resourceURL: string) {
        return this.phttp
            .post(this.API_URL + resourceURL, this.getHeaders(resourceURL))
            .map((res) => res)
            .catch(this.handleError);
    }

    /*
            Function for GET call
            Parameters:
            resourceURL: The resource on which POST call has to be made.
            Return Type: Observable<T>
        */
    makeGetCall(resourceURL: string, params?: URLSearchParams) {
        let options = this.getHeaders(resourceURL);
        if (params) {
            options.params = params;
        }
        return this.phttp
            .get(this.API_URL + resourceURL, options)
            .map((res) => res)
            .share()
            .catch(this.handleError);
    }

    /*
            Function for Delete call
            Parameters:
            resourceURL: The resource on which POST call has to be made.
            Return Type: Observable<T>
        */
    makeDeleteCall(resourceURL: string) {
        return this.phttp
            .delete(this.API_URL + resourceURL, this.getHeaders(resourceURL))
            .catch(this.handleError);
    }

    /*
            Function for PUT call
            Parameters:
            resourceURL: The resource on which PUT call has to be made.
            requestModel: The Request model to be sent along with the call.
            Return Type: Observable<T>
        */
    makePutCall(resourceURL: string, requestModel: any) {
        return this.phttp
            .put(
            this.API_URL + resourceURL,
            this.getJSONfromModel(requestModel),
            this.getHeaders(resourceURL),
        )
            .map((res) => res)
            .catch(this.handleError);
    }

    /*
            Function for PATCH call
            Parameters:
            resourceURL: The resource on which PATCH call has to be made.
            requestModel: The Request model to be sent along with the call.
            Return Type: Observable<T>
        */
    makePatchCall(resourceURL: string, requestModel: any) {
        return this.phttp
            .patch(
            this.API_URL + resourceURL,
            this.getJSONfromModel(requestModel),
            this.getHeaders(resourceURL),
        )
            .map((res) => res)
            .catch(this.handleError);
    }

    /*
            Function for Upload file call
            Parameters:
            resourceURL: The resource on which PATCH call has to be made.
            requestModel: The Request model to be sent along with the call.
            Return Type: Observable<T>
        */
    makeUploadCall(resourceURL: string, requestModel: any) {
        let options = this.getHeaders(resourceURL);
        options.headers.delete("Content-Type");
        //this.headers.append('Accept', 'application/json');
        return this.phttp
            .post(this.API_URL + resourceURL, requestModel, options)
            .map((res) => res)
            .catch(this.handleError);
    }

    makeUploadCallPost(resourceURL: string, requestModel: any) {
        let options = this.getHeaders(resourceURL);
        options.headers.delete("Content-Type");
        // this.headers.append('Accept', 'application/json');
        return this.phttp
            .post(this.API_URL + resourceURL, requestModel, options)
            .map((res) => res)
            .catch(this.handleError);
    }

    /*
            Function for handling errors during an API call
            Parameters:
            error: Error Received on API call
        */

    downLoadFile(downLoadFileLocation: string, fileType: string) {
        let options = this.getHeaders(downLoadFileLocation);
        // this.headers.append('Accept', 'application/json');
        return (
            this.phttp
                .get(downLoadFileLocation, options)
                .subscribe((data) => this.downloadFiletoLocal(data, fileType)), //console.log(data),
            (error) => console.log("Error downloading the file."),
            () => console.info("OK")
        );
    }

    downloadFiletoLocal(data: any, fileType: string) {
        var blob = new Blob([data], { type: fileType });
        var url = window.URL.createObjectURL(blob);
        window.open(url);
    }

    /*
        Function for handling errors during an API call
        Parameters:
        error: Error Received on API call
        */
    private handleError(error: Response | any) {
        this.error = error;
        this.status = error.status;
        if (error._body != null && error.status != 0) {
            this.errorMessage = JSON.parse(error._body).message;
            let errorReason = JSON.parse(error._body).reason;
            if (errorReason == "ACCESS_TOKEN_EXPIRED") {
                swal("Error", "Session Expired!", "error");
                window.location.href = "/logout";
                return;
            }
            if (errorReason == "DUPLICATE_ENTRY") {
                swal(
                    "Error",
                    this.errorMessage +
                    "already present in our records. Please try with a new one!",
                    "error",
                );
                return;
            }
            if (errorReason == "INVALID_ENTRY_ERROR_TO_UI") {
                if (
                    error &&
                    error.url &&
                    (error.url.includes("partnerDetailsByPan") ||
                        error.url.includes("cdp/reports"))
                ) {
                    return Observable.throw(error || "Server Error");
                }
                swal("Error", this.errorMessage, "error");
                return;
            }
            if (errorReason == "VALIDATION_FAILED") {
                swal("Error", this.errorMessage, "error");
                return;
            }
            if (
                errorReason == "INTERNAL_SERVER_ERROR" ||
                errorReason == "EXCHANGE_THIRD_PARTY_SERVICE_ERROR"
            ) {
                swal("Error", "Something went wrong!Please try again", "error");
                return;
            }
        }
        if (this.status === 503) {
            swal("Error...", this.error, "error");
        }
        if (this.status === 401) {
            return Observable.throw(error || "Server Error");
        }
        //  else if (error != null && JSON.parse(error._body).reason != null) {
        //     this.errorMessage = JSON.parse(error._body).reason;
        //     return Observable.throw(error || 'Server Error');
        //     // return
        // }
        else if (this.status === 403) {
            return Observable.throw(error || "Server Error");
            // return
        } else if (this.status === 404) {
            return Observable.throw(error || "Server Error");
            //return
        } else if (this.status === 400) {
            return Observable.throw(error || "Server Error");
        } else {
            swal("Error...", this.errorMessage, "error");
            return Observable.throw(error || "Server Error");
        }
    }

    makePanGetCall(resourceURL: string, params?: URLSearchParams) {
        let panHeaders = new Headers();

        panHeaders.set("channel", "ADMIN_PORTAL");
        panHeaders.set("Content-Type", "application/json");
        panHeaders.set("Cache-Control", "no-cache");
        panHeaders.set("X-AUTH-TOKEN", this.apiKeyTest);

        let panApiOptions = new RequestOptions({ headers: panHeaders });
        return this.phttp
            .get("https://apiqa.wsfx.in/" + resourceURL, panApiOptions)
            .map((res) => res)
            .share()
            .catch(this.handleError);
    }
}



// WEBPACK FOOTER //
// ./src/app/_services/BaseProvider.ts